'use strict';

import 'components/off-canvas';
import './component.scss';
import $ from 'jquery';
import Utils from 'components/utils';
import './empty-burger-menu';

// https://css-tricks.com/snippets/css/remove-gray-highlight-when-tapping-links-in-mobile-safari/
if (!!window.chrome || 'WebkitAppearance' in document.documentElement.style) {
    window.addEventListener('DOMContentLoaded', () =>
    {
        let element = document.getElementById('page-burger-menu');
        element && element.addEventListener("touchstart", () => {}, true);
    });
}

window.addEventListener('DOMContentLoaded', () => {
    accessibility();
});

function changeAriaLabel(element) {
    if (Utils.breakpoint.match('xlarge')) {
        element.setAttribute('aria-label', element.dataset.ariaLabelXlarge);
    } else {
        element.setAttribute('aria-label', element.dataset.ariaLabelSmall);
    }
}

function accessibility() {
    $('#page-burger-menu').on('opened.zf.offCanvas', function(e) {
        // Selects and focuses the first visible and focusable element
        $('#page-burger-menu').find('li:visible:first *').focus();

        $('#page-burger-menu').attr('role', 'dialog');
        $('#page-burger-menu').attr('aria-modal', 'true');
    });

    $('#page-burger-menu').on('close.zf.offCanvas', function(e) {
        $('#page-burger-menu').removeAttr('role');
        $('#page-burger-menu').removeAttr('aria-modal');
    });


    // Change aria label depending on the resolution
    let elements = document.querySelectorAll('.page-burger-menu-toggle, .page-burger-menu');

    if (elements) {
        for (let el of elements) {
            changeAriaLabel(el);
        }
        window.addEventListener('resize', () => {
            for (let el of elements) {
                changeAriaLabel(el);
            }
        });
    }
}